"use client";
import { ElProps} from "@/type";
import { cn } from "utils";
import Link from "next/link";
import { FC } from "react";
import { BindWallet } from "../ConnectWallet";
interface PageHeaderProps extends ElProps {
  address: string;
  loading: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
}

export const PageHeader: FC<PageHeaderProps> = ({ className, ...props }) => {
  const { onConnect, onDisconnect, address, loading } = props;
  return (
    <>
      <div className={cn(
        "flex justify-between py-[12px] items-center",
        "md:gap-10 md:px-5 md:h-fit",
        "lg:gap-20 lg:px-10",
        className)}
      >
        <div className={cn("flex justify-between items-center")}>
          <Link href={process.env.NEXT_PUBLIC_BREAD_HOST as string || ''} target="_blank">
            <div className={cn(
              "w-[160px]"
            )}>
              <img
                src={`${process.env.NEXT_PUBLIC_BASE_PATH}/assets/bread-butter-logo.svg`}
                alt="bread-butter"
              />
            </div>
            <div className={cn("w-[104px] lg:block hidden")}>
              <img
                src={`${process.env.NEXT_PUBLIC_BASE_PATH}/assets/bnb-chain-logo.webp`}
                alt="bnb-chain"
              />
            </div>
          </Link>
          <div className="font-luckiestGuy ml-14 text-xl border-b-4 text-Content-Primary border-Content-Primary">AIRDROP</div>
        </div>
        <BindWallet onConnect={onConnect} onDisconnect={onDisconnect} loading={loading} address={address}/>
      </div>
    </>
  )
}